const branchHeaders = [
    {
      id: "cuit",
      numeric: false,
      disablePadding: false,
      label: "CUIT",
    },
    {
      id: "name",
      numeric: false,
      disablePadding: false,
      label: "NOMBRE",
    },
    {
      id: "state",
      numeric: false,
      disablePadding: false,
      label: "ESTADO",
    },
    
  ];

  export default branchHeaders